/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import schedule from './schedule'
import pool from './pool'
import vehicle from './vehicle'
import geofence from './geofence'
import user from './user'
import assets from './assets'
import books from './books'
import email_template from './email_template'
import router from '../router'
import axios from 'axios'
import get from 'lodash/get'
import includes from 'lodash/includes'

const STORAGE_NAME = `carpool_${process.env.VUE_APP_WEB}`;

Vue.use(Vuex)
Vue.config.devtools = true

const qs = require('qs')

export default new Vuex.Store({
	modules: {
    schedule,
    pool,
    vehicle,
    geofence,
    user,
    assets,
    books,
    email_template,
  },
  state: {
    user: [],
    token: null,
    name: null,
    clientid: null,
    user_id: null,
    type: null,
    error: false,
    errorMsg: null,
    logout_from_button: false,
  },
  getters: {
    getUserData(state) {
      return state.user
    },
    getError(state) {
      return state.error
    },
    getErrorMsg(state) {
      return state.errorMsg
    }
  },
  mutations: {
    ADD_USER_DATA(state, data) {
      state.user = data
    },
    SET_DATA(state, data) {
      state.token = data.token
      state.clientid = data.user.clientid
      state.name = data.user.username
      state.user_id = data.user.id
      state.type = data.user.type
      state.metadata = data.user.metadata
    },
    REMOVE_DATA(state) {
      state.token = null
      state.clientid = null
      state.name = null
      state.user_id = null
      state.type = null
      state.errorMsg = null
    },
    ERROR_STATUS(state, data) {
      state.error = data
    },
    ERROR_MSG(state, data) {
      state.errorMsg = data
    },
    SET_LOGOUT_FROM_BUTTON(state, logout_from_button) {
      state.logout_from_button = logout_from_button
    },
  },
  actions: {
    LOGIN_USER(context, payloads) {
      const {
        username,
        password,
      } = payloads;
      return axios.post(`${process.env.VUE_APP_API_URL}/login`, qs.stringify({
        username,
        password
      }))
        .then(
          (response) => {
            const userData = response.data.data.user;
            if (response.data.code == 401) {
              context.commit('ERROR_STATUS', true)
              context.commit('ERROR_MSG', response.data.data.message)
            } else if (userData.status == 0) {
              context.commit('ERROR_STATUS', true)
              context.commit('ERROR_MSG', "This user has not been approved, please contact the admin")
            } else if (userData.status == 2) {
              context.commit('ERROR_STATUS', true)
              context.commit('ERROR_MSG', "This user is disabled, please contact the admin")
            } else {
              return new Promise((resolve, reject) => {
                try {
                  localStorage.setItem(`USER_DATA_${STORAGE_NAME}`, JSON.stringify({
                    token: response.data.data.token,
                    user_id: userData.id,
                    user: {
                      username: userData.username,
                      type: userData.type,
                      clientid: userData.clientid,
                    },
                    response_login: response.data.data,
                  }))
                } catch (e) {}
                resolve();
              })
              .then(() => {
                context.commit('ERROR_STATUS', false)
                context.commit('SET_DATA', response.data.data)
                context.commit('ADD_USER_DATA', response.data.data)
                router.push({ path:'/book' })
                location.reload();
              })
            }
          }
        )
    },
    LOGOUT(context, payloads) {
      const {
        token
      } = payloads;
      return axios.post(`${process.env.VUE_APP_API_URL}/logout`, qs.stringify({
        token
      }))
        .then(
          (response) => {
            if (response.data.code === 401) {
              context.commit('ERROR_STATUS', true)
              context.commit('ERROR_MSG', response.data.data.message)
            } else {
              return new Promise((resolve, reject) => {
                try {
                  localStorage.removeItem(`USER_DATA_${STORAGE_NAME}`)
                  localStorage.removeItem(`CLIENTID_${STORAGE_NAME}`)
                } catch (e) {}
                resolve();
              })  
              .then(
                () => {
                  context.commit('ERROR_STATUS', false)
                  context.commit('REMOVE_DATA')
                }
              )
            }
          }
        )
    },
    LOAD_TOKEN({ commit, dispatch }) {
      if (localStorage.getItem('vuex')) {
        localStorage.removeItem('vuex');
      }
      return new Promise((resolve, reject) => {
        let userData = '';
        try {
          userData = localStorage.getItem(`USER_DATA_${STORAGE_NAME}`)
        } catch (e) {}
        resolve(userData);
      })
      .then((userData) => {
        if (!userData) return
        userData = JSON.parse(userData)
        if (!userData.hasOwnProperty('response_login')) {
          return dispatch('LOGOUT', { token: userData.token }).then(() => {
            router.push({ path: '/login' });
            location.reload();
          })
        }
        userData.user = userData.response_login.user;
        commit('SET_DATA', userData)
        commit('UPDATE_USER_DATA', userData.response_login.user);
      })
    },
    REGISTER(context, payloads) {
      context.commit('ERROR_STATUS', false)
      context.commit('ERROR_MSG', '')

      const formData = new FormData()

      Object.keys(payloads).forEach((key) => {
        if (key === 'driver_license') payloads[key] = JSON.stringify(payloads[key])
        formData.append(key, payloads[key])
      })

      return axios.post(`${process.env.VUE_APP_API_URL}/create_user`, formData).then((response) => {
        if (response.data.data.error == true || response.data.data.error == 'true') {
          context.commit('ERROR_STATUS', true)
          context.commit('ERROR_MSG', response.data.data.message)
        }
      });
    },
    API_CALL({ commit, state }, payload) {
      const method = payload.$method;
      const postData = payload.$postData || {};
      delete payload.$method;
      delete payload.$postData;

      const { token } = state;
      const authPayload = { token, ...postData, ...payload };
      const query = qs.stringify(authPayload)
      const url   = `${process.env.VUE_APP_API_URL}/${method}`
      return axios.post(url, query)
        .then((response) => {
          if (response) {
            const errorList = [
              'Please login first.',
              'Token not found or you session has ended.',
              'Your session has ended, please relogin.'
            ]
            const message = get(response, 'data.data.message', '')
            if (includes(errorList, message)) {
              commit('SET_LOGOUT_FROM_BUTTON', false);
              return new Promise((resolve, reject) => {
                try {
                  localStorage.removeItem(`USER_DATA_${STORAGE_NAME}`)
                  localStorage.removeItem(`CLIENTID_${STORAGE_NAME}`)
                } catch (e) {}
                resolve();
              })
              .then(() => {
                commit('REMOVE_DATA')
                window.location.reload()
              })
            }
          }
          return response;
        })
    }
  }
})
